
class DataLoadState {
  constructor (id = null) {
    this.id = id;

    this.data = null;
    this.status = {
      loading: false,
      success: false,
      fail: false,
      error: null
    };
  }

  stateForLoadStarted() {
    const clone = new DataLoadState(this.id);

    clone.data = null;
    clone.status.loading = true;
    clone.status.success = false;
    clone.status.fail = false;
    clone.status.error = null;

    return clone;
  }

  stateForLoadFinished(data) {
    const clone = new DataLoadState(this.id);

    clone.data = data;
    clone.status.loading = false;
    clone.status.success = true;
    clone.status.fail = false;
    clone.status.error = null;

    return clone;
  }

  stateForLoadFailed(error) {
    const clone = new DataLoadState(this.id);

    clone.data = null;
    clone.status.loading = false;
    clone.status.success = false;
    clone.status.fail = true;
    clone.status.error = error || 'Something went wrong.';

    return clone;
  }
}


export { DataLoadState };
